import { tokenDaApi } from "./auth-token";

export function setupInterceptors(api) {
  api.interceptors.request.use(
    async (config) => {
      const requestUrl = String(config?.url || "");
      const isPublicCampaignSignup = requestUrl.includes(
        "/auth/register-campaign-carrier",
      );
      if (isPublicCampaignSignup) {
        return config;
      }

      const token = await tokenDaApi();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        console.error("Usuário não autenticado ou token expirado.");
      }

      return Promise.reject(error);
    }
  );
}